import { render, staticRenderFns } from "./Opcional.vue?vue&type=template&id=6bc05f31&scoped=true&"
import script from "./Opcional.vue?vue&type=script&lang=js&"
export * from "./Opcional.vue?vue&type=script&lang=js&"
import style0 from "./Opcional.vue?vue&type=style&index=0&id=6bc05f31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc05f31",
  null
  
)

export default component.exports